import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
export const detailPaneStyleId = 'wb-v2-detail-pane-theme';
export const detailPaneBridgeStyles = {
  'detail-pane': {
    '--local-detail-pane-font': tokens.font.family.body,
    '--local-detail-pane-text': tokens.color.text.tertiary,
    '--local-detail-pane-gap': tokens.spacing.sm,
    '--local-detail-pane-padding': tokens.spacing.lg,
    '--local-detail-pane-state-padding': tokens.spacing.sixXl,
    '--local-detail-pane-font-size': tokens.font.size.textSm,
    '--local-detail-pane-icon-size': tokens.font.size.textLg,
    '--local-detail-pane-background': tokens.color.background.primary,
    '--local-detail-pane-slide-duration': '180ms',
    '--local-detail-pane-slide-easing': 'ease-out',
    '--local-detail-pane-child-layer': '1',
  },
};
